import axios from "axios";
import { getHeaders, getURl } from "./core";
import { Util } from "common/util";

let url = `${getURl()}/employee/v1`;

export function getMany({ offset = 0, limit = 15, filter = "", contractExpired = false, isResigned = false, search = "",newHire= false}) {
  const result = axios({
    method: "GET",
    headers: getHeaders(),
    url: `${url}/lists?offset=${offset}&limit=${limit}&filter=${filter}&contractExpired=${contractExpired}&newHire=${newHire}&isResigned=${isResigned}&search=${search}`,
  });
  return new Promise((resolve, reject) => {
    result
      .then((response) => resolve(response.data))
      .catch((error) => reject(error));
  });
}

export function getLeaveTypes() {
  const result = axios({
    method: "GET",
    headers: getHeaders(),
    url: `${url}/leave_types`,
  });
  return new Promise((resolve, reject) => {
    result
      .then((response) => resolve(response.data))
      .catch((error) => reject(error));
  });
}

export function getResignedEmployes(payrollDate) {
  const result = axios({
    method: "GET",
    headers: getHeaders(),
    url: `${url}/resigned_employees?byPayrollDate=${payrollDate}`,
  });
  return new Promise((resolve, reject) => {
    result
      .then((response) => resolve(response.data))
      .catch((error) => reject(error));
  });
}

export function getActingProfile(employeeId) {
  const result = axios({
    method: "GET",
    headers: getHeaders(),
    url: `${url}/acting_profile/${employeeId}`,
  });
  return new Promise((resolve, reject) => {
    result
      .then((response) => resolve(response.data))
      .catch((error) => reject(error));
  });
}

export function getLineManagerByEmployeeId(employeeId) {
  const result = axios({
    method: "GET",
    headers: getHeaders(),
    url: `${url}/line_manager/${employeeId}`,
  });
  return new Promise((resolve, reject) => {
    result
      .then((response) => resolve(response.data))
      .catch((error) => reject(error));
  });
}

export function getByRoleCode(roleCode) {
  const result = axios({
    method: "GET",
    headers: getHeaders(),
    url: `${url}/lists?roleCode=${roleCode}`,
  });
  return new Promise((resolve, reject) => {
    result
      .then((response) => resolve(response.data))
      .catch((error) => reject(error));
  });
}

export function getOne(id) {
  const result = axios({
    method: "GET",
    url: `${url}/detail/${id}`,
    headers: getHeaders(),
  });
  return new Promise((resolve, reject) => {
    result
      .then((response) => resolve(response.data))
      .catch((error) => reject(error));
  });
}

export function getProfile(id) {
  const result = axios({
    method: "GET",
    url: `${url}/profile/${id}`,
    headers: getHeaders(),
  });
  return new Promise((resolve, reject) => {
    result
      .then((response) => resolve(response.data))
      .catch((error) => reject(error));
  });
}

export function insertNewRecord(data) {
  return axios({
    method: "POST",
    url: `${url}/create`,
    headers: getHeaders(),
    data,
  });
}

export function updateRecordById(id, dataToUpdate) {
  return axios({
    method: "PUT",
    url: `${url}/update/${id}`,
    headers: getHeaders(),
    data: dataToUpdate,
  });
}

export function softDeleteById(id) {
  return axios({
    method: "DELETE",
    url: `${url}/archive/${id}`,
    headers: getHeaders(),
  });
}

export function getEmployeesLeave(id) {
  const result = axios({
    method: "GET",
    url: `${url}/leave_balance/${id}`,
    headers: getHeaders(),
  });
  return new Promise((resolve, reject) => {
    result
      .then((response) => resolve(response.data))
      .catch((error) => reject(error));
  });
}

export function getFormPayload() {
  const result = axios({
    method: "GET",
    url: `${url}/form_payload`,
    headers: getHeaders(),
  });
  return new Promise((resolve, reject) => {
    result
      .then((response) => resolve(response.data))
      .catch((error) => reject(error));
  });
}

export function getEmployeesBenefit(id) {
  const result = axios({
    method: "GET",
    url: `${url}/employee_benefit/${id}`,
    headers: getHeaders(),
  });
  return new Promise((resolve, reject) => {
    result
      .then((response) => resolve(response.data))
      .catch((error) => reject(error));
  });
}

export function clearAllSesionEmployee(roleId) {
  return axios({
    method: "PUT",
    url: `${url}/clear_all_sesion_employee/${roleId}`,
    headers: getHeaders(),
  });
}

export function updateEmployeeLeave(dataToUpdate) {
  return axios({
    method: "PUT",
    url: `${url}/leave_balance`,
    headers: getHeaders(),
    data: dataToUpdate,
  });
}

export function markAsPassedProbation(employeeId, probationEndDate) {
  return axios({
    method: "PUT",
    url: `${url}/mark_as_passed_probation/${employeeId}`,
    data: { probationEndDate },
    headers: getHeaders()
  });
}

export function resetPassword(id, password) {
  return axios({
    method: "PUT",
    url: `${getURl()}/user/v1/reset/password`,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${Util.getInstance().getAccessToken()}`,
      id: id,
      password: password,
    },
    data: {},
  });
}

export function getEmployeeCertificates(id) {
  return axios({
    method: "GET",
    url: `${getURl()}/file/v1/employee_certificates/${id}`,
    headers: getHeaders(),
  });
}

export function getEmployeeBenefits(id) {
  return axios({
    method: "GET",
    url: `${getURl()}/file/v1/employee_benefit/${id}`,
    headers: getHeaders(),
  });
}

export function getEmployeeHistory(id, type) {
  return axios({
    method: "GET",
    url: `${getURl()}/employee/v1/histories/${id}?type=${type}`,
    headers: getHeaders(),
  });
}

export function exportEmployees({ offset = 0, limit = 15, filter = "", contractExpired = false, isResigned = false, search = "",newHire= false}) {
  const result = axios({
    method: "GET",
    url: `${url}/export?offset=${offset}&limit=${limit}&filter=${filter}&contractExpired=${contractExpired}&newHire=${newHire}&isResigned=${isResigned}&search=${search}`,
    headers: getHeaders(),
  });

  return new Promise((resolve, reject) => {
    result
      .then((response) => resolve(response.data))
      .catch((error) => reject(error));
  });
}
